import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';

import { WS_URL } from '@/api/config';
import { isAuthCloseEvent, isIntentionalCloseEvent } from '@/api/errors';
import { getUserToken } from '@/shared/services/user-hash';
import { dispatch } from '@/store';
import {
  resetConnection,
  setConnectionConnected,
  setConnectionConnecting,
  setConnectionLost
} from '@/store/connection.slice';

/**
 * Клиент сокета GraphQL-подписок. Ленивый: соединение открывается с первой
 * подпиской и закрывается, когда подписок не осталось. Статус соединения
 * пишется в `state.connection` — по нему Layout показывает баннер «нет связи».
 */
export const wsClient = createClient({
  url: WS_URL,
  lazy: true,
  // Функция, а не объект: вызывается на каждое (пере)подключение и берёт актуальный токен.
  connectionParams: () => {
    const { accessToken } = getUserToken();
    return accessToken ? { authorization: `Bearer ${accessToken}` } : {};
  },
  // Переподключаемся бесконечно (паузы растут экспоненциально — встроено в graphql-ws),
  // кроме отказа по токену: там поможет только новый вход (см. apollo/client.ts).
  retryAttempts: Infinity,
  shouldRetry: (event) => !isAuthCloseEvent(event),
  on: {
    connecting: (isRetry) => dispatch(setConnectionConnecting(isRetry)),
    connected: () => dispatch(setConnectionConnected()),
    closed: (event) =>
      dispatch(
        isIntentionalCloseEvent(event) ? resetConnection() : setConnectionLost()
      )
  }
});

/** Терминальный link для операций-подписок. */
export const wsLink = new GraphQLWsLink(wsClient);
